import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import urls, { relativeUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { refreshSearches, confirmSearchesDeletion } from '../actions';
import { searchPermissions } from '../constants';

const SearchesActions = ({
  category,
  readStatus,
  allowCreate,
  allowRefresh,
  allowDelete,
  disableDelete,
  refresh,
  showDelete,
}) => (
  <>
    {allowCreate && (<CreateAction url={`#${relativeUrl(urls.SEARCH)}`} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={disableDelete} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  search: { searches },
}, { category }) => {
  const { readStatus } = searches[category];
  const selected = findSelectedInCategory(searches, category);
  const denyDestroy = selected.some((search) => !search.permissions[searchPermissions.DESTROY]);

  return {
    allowRefresh: permissions.search.read,
    allowCreate: permissions.search.create,
    allowDelete: permissions.search.destroy,
    disableDelete: denyDestroy || readStatus === states.PENDING || selected.length === 0,
    readStatus,
  };
};

const mapDispatchToProps = {
  refresh: refreshSearches,
  showDelete: confirmSearchesDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchesActions);
